import Vue from 'vue'
import Router from 'vue-router'

const Home = () => import(/* webpackChunkName: "Home" */ '../components/Home');
const Login = () => import(/* webpackChunkName: "Login" */ '../components/Login');

const ForgotPassword = () => import(/* webpackChunkName: "ForgotPassword" */ '../components/ForgotPassword');
const ChangePassword = () => import(/* webpackChunkName: "ChangePassword" */ '../components/ChangePassword');
const ResetPassword = () => import(/* webpackChunkName: "ResetPassword" */ '../components/ResetPassword');

const Sites = () => import(/* webpackChunkName: "Sites" */ '../components/Sites');
const Site = () => import(/* webpackChunkName: "Site" */ '../components/Site');
const Booker = () => import(/* webpackChunkName: "Booker" */ '../components/booker/Booker');
const Scheduler = () => import(/* webpackChunkName: "Scheduler" */ '../components/Scheduler');
const Clubs = () => import(/* webpackChunkName: "Clubs" */ '../components/Clubs/Clubs');
const Reports = () => import(/* webpackChunkName: "Reports" */ '../components/Reports');
const Profile = () => import(/* webpackChunkName: "Profile" */ '../components/Profile');
const Help = () => import(/* webpackChunkName: "Help" */ '../components/Help');


const AdminClients = () => import(/* webpackChunkName: "AdminClients" */ '../components/admin/Clients/Clients');
const AdminSites = () => import(/* webpackChunkName: "AdminSites" */ '../components/admin/Sites/Sites');
const AdminFields = () => import(/* webpackChunkName: "AdminFields" */ '../components/admin/Fields/Fields');
const AdminScenes = () => import(/* webpackChunkName: "AdminScenes" */ '../components/admin/Scenes/Scenes');
const AdminUsers = () => import(/* webpackChunkName: "AdminUsers" */ '../components/admin/Users/Users');
const AdminDevices = () => import(/* webpackChunkName: "AdminDevices" */ '../components/admin/Devices/Devices');
const AdminLights = () => import(/* webpackChunkName: "AdminLights" */ '../components/admin/Lights/Lights');
const AdminSettings = () => import(/* webpackChunkName: "AdminSettings" */ '../components/admin/Settings');

const Unauthorized = () => import(/* webpackChunkName: "Unauthorized" */ '../components/Unauthorized');


// import Login from '../components/Login'
// import ForgotPassword from '../components/ForgotPassword'
// import ResetPassword from '../components/ResetPassword'
// import ChangePassword from '../components/ChangePassword'
// import Help from '../components/Help'
// import Home from '../components/Home'
// import Sites from '../components/Sites'
// import Site from '../components/Site'
// import Scheduler from '../components/Scheduler'
// import Booker from '../components/booker/Booker'
// import Reports from '../components/Reports'
// import Profile from '../components/Profile'
// import Unauthorized from '../components/Unauthorized'

// import AdminSites from '../components/admin/Sites/Sites'
// import AdminFields from '../components/admin/Fields/Fields'
// import AdminScenes from '../components/admin/Scenes/Scenes'
// import AdminUsers from '../components/admin/Users/Users'
// import AdminClients from '../components/admin/Clients/Clients'
// import AdminDevices from '../components/admin/Devices/Devices'
// import AdminLights from '../components/admin/Lights/Lights'
// import AdminSettings from '../components/admin/Settings'


//import Docs from '../components/Docs'

import requests from '../requests';
import auth from '../auth'

var Docs = {
  template:'<div>Hello world</div>'
}

Vue.use(Router)

export default new Router({
  mode:"history",
  routes: [
    { path: '/', component: Home},
    { path: '/login', component: Login},
    { path: '/forgot-password', component: ForgotPassword},
    { path: '/resetPassword', component: ResetPassword},
    { path: '/change_password', component: ChangePassword},
    { path: '/help', component: Help},
    { path: '/sites', component: Sites},
    { path: '/site/:id', component: Site},
    { path: '/booking', component: Booker},
    { path: '/scheduler', component: Scheduler},
    { path: '/clubs', component: Clubs},
    { path: '/reports', component: Reports},
    { path: '/profile', component: Profile},
    { path: '/admin/clients', component: AdminClients, beforeEnter: superAdminOnly},
    { path: '/admin/clients/:id', component: AdminSites, beforeEnter: superAdminOnly},
    { path: '/admin/clients/:clientId/site/:id', component: AdminFields, beforeEnter: superAdminOnly},
    { path: '/admin/clients/:clientId/site/:siteId/field/:id', component: AdminScenes, beforeEnter: superAdminOnly},
    { path: '/admin/clients/:clientId/site/:siteId/field/:id/lights', component: AdminLights, beforeEnter: superAdminOnly},
    { path: '/admin/settings', component: AdminSettings, beforeEnter: superAdminOnly},
    { path: '/admin/users', component: AdminUsers},
    { path: '/admin/devices', component: AdminDevices, beforeEnter: superAdminOnly},
    { path: '/unauthorized', component: Unauthorized},
    { path: '/docs', component: Docs, beforeEnter: (to, from, next)=>{
      /*req.get('https://www.google.com.au', function(err, res, body){
        console.log(res.statusCode);
      });*/
      console.log('rendering..');
      console.log(this.a.app);
      requests.renderDocs(this.a.app, function(result){

        Docs.template = '<template><div class="docs">' + result + '</div></template>';
        
        console.log(Docs.template);
        next();
      });
    }},
  ],
});

function superAdminOnly(to, from, next) {
  var profile = JSON.parse(auth.getProfile());
  if(profile.role == 3) {
    next()
  } else {
    next('/unauthorized')
  } 
}


// WEBPACK FOOTER //
// ./src/router/index.js